"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shapeSquare = shapeSquare;
// =============================================================================
// SHAPES (Tools)
// =============================================================================
// Triangle
// -----------------------------------------------------------------------------
//* * TODO or remove: **/
// @mixin shape-triangle($triangle-direction, $triangle-size, $triangle-color) {
//   border: inset $triangle-size;
//   content: '';
//   display: block;
//   height: 0;
//   width: 0;
//   @if ($triangle-direction == 'up') {
//     border-bottom-style: solid;
//     border-color: transparent transparent $triangle-color;
//   }
//   @if ($triangle-direction == 'down') {
//     border-color: $triangle-color transparent transparent;
//     border-top-style: solid;
//   }
//   @if ($triangle-direction == 'left') {
//     border-color: transparent $triangle-color transparent transparent;
//     border-right-style: solid;
//   }
//   @if ($triangle-direction == 'right') {
//     border-color: transparent transparent transparent $triangle-color;
//     border-left-style: solid;
//   }
// }
// Square
// -----------------------------------------------------------------------------
function shapeSquare(squareSize) {
    return "\n    height: " + squareSize + ";\n    width: " + squareSize + ";\n  ";
}
// Circle
// -----------------------------------------------------------------------------
//* * TODO or remove: **/
// @mixin shape-circle($circle-size: null) {
//   @if ($circle-size) {
//     border-radius: ($circle-size / 2);
//     @include shape-square($circle-size);
//   } @else {
//     border-radius: 50%;
//   }
// }
//# sourceMappingURL=shape.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/tools/shape.js